import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const GameWrapper = styled(Box)<{ maxWidth: string }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};

  & .MuiTypography-root {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;
